import Slider from '../app/slider';

export default {
    init() {
        const tabs = jQuery('section.process header a');
        const content = jQuery('section.process .tab-content');
        tabs.on('click', (e) => {
            e.preventDefault();
            tabs.parents('h4').removeClass('active');
            jQuery(e.currentTarget).parent('h4').addClass('active');

            content.hide();
            content.filter(jQuery(e.currentTarget).attr('href')).show();
            jQuery(window).trigger('resize');
        });
        tabs.eq(0).trigger('click');

        new Slider('section.testimonials-slider', {
            dots: false,
            nav: true,
            navText: ['<i class="icon icon-chevron-left"></i>', '<i class="icon icon-chevron-right"></i>'],
            animateOut: false,
            autoplayTimeout: 7500,
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/DesignSolutions.js